import React, { useState } from 'react';
// @ts-ignore
import styles from './InformedConsentsList.module.scss';
import ScrollContainer from '../../../BaseModule/Components/ScrollContainer/ScrollContainer';
import FlatList from '../../../BaseModule/Components/FlatList/FlatList';
import InformedConsentsListItem from './InformedConsentsListItem';
import useFlatData from '../../../BaseModule/Hooks/useFlatData';
import useInformedConsents from '../../Hooks/useInformedConsents';
import UserPicker from '../../../Case/Components/Create/UserPicker/UserPicker';

interface Props {
	userId: string;
	userIds: string[];
	linkFamilyMemberCreate: string;
}

const WRAPPER_ID = 'InformedConsentsListWrapper';

const InformedConsentsList: React.FC<Props> = ({ userId, userIds, linkFamilyMemberCreate }) => {
	const [selectedUserId, setSelectedUserId] = useState<string>(userId);
	const { getFlatInformedConsents, getNextPage, data, isLoading, page, setPage } = useInformedConsents();
	const { flatData, hasMoreData, loadData, setFilter } = useFlatData(
		getFlatInformedConsents,
		{
			data: data?.userConsents?.data,
			totalPages: data?.userConsents?.meta?.totalPages,
			page: data?.userConsents?.meta?.page,
		},
		page,
		setPage,
		{
			userId,
		},
	);

	const handleSelectUser = (userId: string) => {
		setSelectedUserId(userId);
		setFilter({
			userId
		})
	};

	return (
		<div className={styles.wrapper}>
			<UserPicker userIds={userIds} selectedUserId={selectedUserId} linkFamilyMemberCreate={linkFamilyMemberCreate}
									onSelect={handleSelectUser} label='component.informedConsentsList.userPickerLabel'
									addAvailable={false} />
			<div className={styles.list}>
				<ScrollContainer wrapperId={WRAPPER_ID}>
					<FlatList onRefresh={loadData}
										onLoadMore={getNextPage}
										data={flatData}
										isLoading={isLoading}
										className={styles.flatWrapper}
										hasMoreData={hasMoreData} scrollableTargetId={WRAPPER_ID}
										renderItem={(item) => <InformedConsentsListItem item={item} onRevoke={loadData}/>}
					/>
				</ScrollContainer>
			</div>
		</div>
	);
};

export default InformedConsentsList;